console.log('Ready javascript');

// Legacy workaround for enabling :active on iOS (now obsolete as of 2025)
// Modern iOS Safari and Android browsers no longer require this hack
// document.addEventListener("touchstart", function(){}, true);







